import { render } from "./ShowPrintBAPVA.vue?vue&type=template&id=32fe3a2c&scoped=true"
import script from "./ShowPrintBAPVA.vue?vue&type=script&lang=js"
export * from "./ShowPrintBAPVA.vue?vue&type=script&lang=js"

import "./ShowPrintBAPVA.vue?vue&type=style&index=0&id=32fe3a2c&lang=css"
import "./ShowPrintBAPVA.vue?vue&type=style&index=1&id=32fe3a2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fe3a2c"]])

export default __exports__